import React, { useState, useEffect } from 'react';
import Firecracker from './Firecracker';
import LuckyDrawButton from './LuckyDrawButton';
import LuckyDrawModal from './LuckyDrawModal';
import './SpringFestivalEffect.scss';

/**
 * 春節特效 - 鞭炮動畫 + 金元寶掉落 + 抽籤功能
 */
const SpringFestivalEffect = () => {
  const [toggleFirecracker, setToggleFirecracker] = useState(true);
  const [showLuckyDraw, setShowLuckyDraw] = useState(false);

  useEffect(() => {
    const interval = setInterval(() => {
      setToggleFirecracker(prev => !prev);
    }, 2000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <div className="spring-festival-effect">
      {/* 左側鞭炮 */}
      {toggleFirecracker && (
        <>
        <div className="firecracker-left">
          <Firecracker width={100} height={250} />
        </div>

        <div className="firecracker-right">
          <Firecracker width={100} height={250} />
        </div>
        </>
      )}

      {/* 抽籤按鈕 */}
      <LuckyDrawButton onClick={() => setShowLuckyDraw(true)} />

      {/* 金元寶掉落 */}
      <div className="gold-ingots" aria-hidden="true">
        {[...Array(25)].map((_, i) => (
          <div key={i} className="gold-ingot">
            <svg viewBox="0 0 40 30" xmlns="http://www.w3.org/2000/svg">
              <defs>
                <linearGradient id={`gold-gradient-${i}`} x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" stopColor="#ffd700" />
                  <stop offset="50%" stopColor="#ffed4e" />
                  <stop offset="100%" stopColor="#d4af37" />
                </linearGradient>
                <filter id={`shadow-${i}`}>
                  <feDropShadow dx="0" dy="2" stdDeviation="2" floodColor="#b8860b" floodOpacity="0.5"/>
                </filter>
              </defs>
              <path
                d="M 10 8 Q 10 5, 20 5 Q 30 5, 30 8 L 35 22 Q 35 25, 20 25 Q 5 25, 5 22 Z"
                fill={`url(#gold-gradient-${i})`}
                filter={`url(#shadow-${i})`}
                stroke="#d4af37"
                strokeWidth="0.5"
              />
              <ellipse cx="20" cy="8" rx="8" ry="2" fill="#ffed4e" opacity="0.6" />
              <ellipse cx="20" cy="20" rx="6" ry="2" fill="#b8860b" opacity="0.4" />
              <text x="20" y="18" fontSize="8" fill="#ff0000" textAnchor="middle" fontWeight="bold" opacity="0.7">福</text>
            </svg>
          </div>
        ))}
      </div>

      {/* 抽籤 Modal */}
      {showLuckyDraw && (
        <LuckyDrawModal onClose={() => setShowLuckyDraw(false)} />
      )}
    </div>
  );
};

export default SpringFestivalEffect;
